import type { CleaningRangeSummaryResponse } from '@/shared/api';

export interface OperationalApartmentRow {
  propertyId: string;
  name: string;
  byDate: Map<string, CleaningRangeSummaryResponse[]>;
}

export function buildOperationalApartmentRows(
  tasks: CleaningRangeSummaryResponse[],
  visibleDates: string[],
  nameOf: (propertyId: string) => string | undefined,
): OperationalApartmentRow[] {
  const dateSet = new Set(visibleDates);
  const rows = new Map<string, OperationalApartmentRow>();

  for (const task of tasks) {
    if (!dateSet.has(task.scheduledFor)) continue;
    let row = rows.get(task.propertyId);
    if (!row) {
      row = {
        propertyId: task.propertyId,
        name: nameOf(task.propertyId) ?? `${task.propertyId.slice(0, 8)}…`,
        byDate: new Map(),
      };
      rows.set(task.propertyId, row);
    }
    const bucket = row.byDate.get(task.scheduledFor);
    if (bucket) bucket.push(task);
    else row.byDate.set(task.scheduledFor, [task]);
  }

  return [...rows.values()].sort((a, b) => a.name.localeCompare(b.name, 'de'));
}
